/**
 * @Author:
 * @Description:
 * @DateTime: Created in 16:31 2019-07-06
 */
import Keep from "../layout/keep";
import Layout from '../layout/layout';

// let DataManage = [
// 	{
// 		path: '/:type/dataManage',
// 		name: 'dataManage',
// 		meta: {title: '数据管理'},
// 		redirect: '/dataManage/dataView/index',
// 		component: Layout,
// 		children: [
// 			{
// 				path: 'dataView',
// 				meta: {title: '数据查看'},
// 				name: 'dataView',
// 				component: Keep,
// 				redirect: '/dataManage/dataView/list',
// 				children: [
// 					{
// 						path: 'list',
// 						meta: {title: '数据查看', cache: ['data-manage-data-view']},
// 						name: 'data-manage-data-view',
// 						component: () => import('src/pages/dataManage/dataView/dataView'),
//                     },
//                     {
// 						path: 'detail',
// 						meta: {title: '单站点数据', cache: ['data-manage-data-view','data-manage-data-view-detail']},
// 						name: 'data-manage-data-view',
// 						component: () => import('src/pages/dataManage/dataView/dataViewDetailList'),
// 					}
// 				]
//             },
//             {
// 				path: 'dataAudit',
// 				meta: {title: '数据审核'},
// 				name: 'dataAudit',
// 				component: Keep,
// 				redirect: '/dataManage/dataAudit/index',
// 				children: [
// 					{
// 						path: 'index',
// 						meta: {title: '数据审核', cache: ['data-manage-data-audit']},
// 						name: 'data-manage-data-audit',
// 						component: () => import('src/pages/dataManage/dataAudit/dataAudit'),
//                     },
//                     {
// 						path: 'handle',
// 						meta: {title: '数据审核', cache: ['data-manage-data-view-detail','data-manage-data-view']},
// 						name: 'data-manage-data-audit-handle',
// 						component: () => import('src/pages/dataManage/dataAudit/handleAudit'),
// 					}
// 				]
//             },
//             {
// 				path: 'dataComplete',
// 				meta: {title: '数据补遗'},
// 				name: 'dataComplete',
// 				component: Keep,
// 				redirect: '/dataManage/dataComplete/index',
// 				children: [
// 					{
// 						path: 'index',
// 						meta: {title: '数据补遗', cache: ['data-manage-data-complete']},
// 						name: 'data-manage-data-complete',
// 						component: () => import('src/pages/dataManage/dataComplete/dataComplete'),
//                     },
//                     {
// 						path: 'handle',
// 						meta: {title: '数据补遗', cache: ['data-manage-data-view-detail','data-manage-data-view']},
// 						name: 'data-manage-data-complete-handle',
// 						component: () => import('src/pages/dataManage/dataComplete/handleComplete'),
// 					}
// 				]
// 			},
// 		]
// 	},
// ]

let DataManage = [
	{
		path: '/:type/dataManage',
        name: 'dataManage',
        component: Layout,
		children: [
			{
                path: 'dataView',
                name: 'dataView',
                meta: { title: '数据查看' },
                component: Keep,
                children: [
                    {
                        path: 'list',
                        name: 'data-manage-data-view',
                        meta: { title: '数据查看' },
                        component: () => import('src/pages/dataManage/dataView/dataView'),
                    },
                ],
            },
			{
                path: 'dataView',
                name: 'dataView',
                meta: { title: '单站点数据1' },
                component: Keep,
                children: [
                    {
                        path: 'detail',
                        name: 'data-manage-data-view',
                        meta: { title: '单站点数据' },
                        component: () => import('src/pages/dataManage/dataView/newDataView/DataViewDetailList'),
                    },
                ],
            },
			{
                path: 'dataAudit',
                name: 'dataAudit',
                meta: { title: '数据审核' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'data-manage-data-audit',
                        meta: { title: '数据审核' },
						// component: () => import('src/pages/dataManage/dataView/dataAudit'),
                        component: () => import('src/pages/dataManage/dataView/newDataView/DataAudit'),
                    },
					{
						path: 'handle',
						meta: {title: '数据审核', cache: ['data-manage-data-view-detail','data-manage-data-view']},
						name: 'data-manage-data-audit-handle',
						component: () => import('src/pages/dataManage/dataAudit/handleAudit'),
					}
                ],
            },
			{
                path: 'dataComplete',
                name: 'dataComplete',
                meta: { title: '数据补遗' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'data-manage-data-complete',
                        meta: { title: '数据补遗' },
						// component: () => import('src/pages/dataManage/dataComplete/dataComplete'),
                        component: () => import('src/pages/dataManage/dataView/newDataView/DataComplete'),
                    },
					{
						path: 'handle',
						meta: {title: '数据补遗', cache: ['data-manage-data-view-detail','data-manage-data-view']},
						name: 'data-manage-data-complete-handle',
						component: () => import('src/pages/dataManage/dataComplete/handleComplete'),
					}
                ],
            }
		]
	},
]

export default DataManage
